var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-login",class:{ 'md-card-hidden': _vm.cardHidden }},[_c('md-card-content',[_vm._t("description")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }